/* tslint:disable */
/* eslint-disable */
//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain (auto-generated; do not edit)
// </auto-generated>
//----------------------
// ReSharper disable InconsistentNaming

import { mergeMap as _observableMergeMap, catchError as _observableCatch } from 'rxjs/operators';
import { Observable, throwError as _observableThrow, of as _observableOf } from 'rxjs';
import { Injectable, Inject, Optional, InjectionToken } from '@angular/core';
import { HttpClient, HttpHeaders, HttpResponse, HttpResponseBase } from '@angular/common/http';

export const AUTH_API_BASE_URL = new InjectionToken<string>('AUTH_API_BASE_URL');

@Injectable()
export class AuthApiGeneratedService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(AUTH_API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    accessToken(body: AccessTokenReq | undefined): Observable<AccessTokenRes> {
        let url_ = this.baseUrl + "/v1/Auth/AccessToken";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAccessToken(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAccessToken(<any>response_);
                } catch (e) {
                    return <Observable<AccessTokenRes>><any>_observableThrow(e);
                }
            } else
                return <Observable<AccessTokenRes>><any>_observableThrow(response_);
        }));
    }

    protected processAccessToken(response: HttpResponseBase): Observable<AccessTokenRes> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AccessTokenRes.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = AccessTokenRes.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<AccessTokenRes>(<any>null);
    }

    /**
     * @param api_version (optional) The requested API version
     * @param body (optional) 
     * @return Success
     */
    accessToken2(api_version: string | undefined, body: AccessTokenReq | undefined): Observable<AccessTokenRes> {
        let url_ = this.baseUrl + "/Auth/AccessToken?";
        if (api_version === null)
            throw new Error("The parameter 'api_version' cannot be null.");
        else if (api_version !== undefined)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAccessToken2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAccessToken2(<any>response_);
                } catch (e) {
                    return <Observable<AccessTokenRes>><any>_observableThrow(e);
                }
            } else
                return <Observable<AccessTokenRes>><any>_observableThrow(response_);
        }));
    }

    protected processAccessToken2(response: HttpResponseBase): Observable<AccessTokenRes> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AccessTokenRes.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = AccessTokenRes.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<AccessTokenRes>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    refreshToken(body: RefreshTokenReq | undefined): Observable<RefreshTokenRes> {
        let url_ = this.baseUrl + "/v1/Auth/RefreshToken";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRefreshToken(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRefreshToken(<any>response_);
                } catch (e) {
                    return <Observable<RefreshTokenRes>><any>_observableThrow(e);
                }
            } else
                return <Observable<RefreshTokenRes>><any>_observableThrow(response_);
        }));
    }

    protected processRefreshToken(response: HttpResponseBase): Observable<RefreshTokenRes> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RefreshTokenRes.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RefreshTokenRes.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<RefreshTokenRes>(<any>null);
    }

    /**
     * @param api_version (optional) The requested API version
     * @param body (optional) 
     * @return Success
     */
    refreshToken2(api_version: string | undefined, body: RefreshTokenReq | undefined): Observable<RefreshTokenRes> {
        let url_ = this.baseUrl + "/Auth/RefreshToken?";
        if (api_version === null)
            throw new Error("The parameter 'api_version' cannot be null.");
        else if (api_version !== undefined)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRefreshToken2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRefreshToken2(<any>response_);
                } catch (e) {
                    return <Observable<RefreshTokenRes>><any>_observableThrow(e);
                }
            } else
                return <Observable<RefreshTokenRes>><any>_observableThrow(response_);
        }));
    }

    protected processRefreshToken2(response: HttpResponseBase): Observable<RefreshTokenRes> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RefreshTokenRes.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RefreshTokenRes.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<RefreshTokenRes>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    changeCustomer(body: ChangeCustomerReq | undefined): Observable<ChangeCustomerRes> {
        let url_ = this.baseUrl + "/v1/Auth/ChangeCustomer";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processChangeCustomer(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processChangeCustomer(<any>response_);
                } catch (e) {
                    return <Observable<ChangeCustomerRes>><any>_observableThrow(e);
                }
            } else
                return <Observable<ChangeCustomerRes>><any>_observableThrow(response_);
        }));
    }

    protected processChangeCustomer(response: HttpResponseBase): Observable<ChangeCustomerRes> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ChangeCustomerRes.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ChangeCustomerRes.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ChangeCustomerRes>(<any>null);
    }

    /**
     * @param api_version (optional) The requested API version
     * @param body (optional) 
     * @return Success
     */
    changeCustomer2(api_version: string | undefined, body: ChangeCustomerReq | undefined): Observable<ChangeCustomerRes> {
        let url_ = this.baseUrl + "/Auth/ChangeCustomer?";
        if (api_version === null)
            throw new Error("The parameter 'api_version' cannot be null.");
        else if (api_version !== undefined)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processChangeCustomer2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processChangeCustomer2(<any>response_);
                } catch (e) {
                    return <Observable<ChangeCustomerRes>><any>_observableThrow(e);
                }
            } else
                return <Observable<ChangeCustomerRes>><any>_observableThrow(response_);
        }));
    }

    protected processChangeCustomer2(response: HttpResponseBase): Observable<ChangeCustomerRes> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ChangeCustomerRes.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ChangeCustomerRes.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ChangeCustomerRes>(<any>null);
    }

    /**
     * @return Success
     */
    authInfo(): Observable<AuthInfoRes> {
        let url_ = this.baseUrl + "/v1/Auth/AuthInfo";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAuthInfo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAuthInfo(<any>response_);
                } catch (e) {
                    return <Observable<AuthInfoRes>><any>_observableThrow(e);
                }
            } else
                return <Observable<AuthInfoRes>><any>_observableThrow(response_);
        }));
    }

    protected processAuthInfo(response: HttpResponseBase): Observable<AuthInfoRes> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AuthInfoRes.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<AuthInfoRes>(<any>null);
    }

    /**
     * @param api_version (optional) The requested API version
     * @return Success
     */
    authInfo2(api_version: string | undefined): Observable<AuthInfoRes> {
        let url_ = this.baseUrl + "/Auth/AuthInfo?";
        if (api_version === null)
            throw new Error("The parameter 'api_version' cannot be null.");
        else if (api_version !== undefined)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAuthInfo2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAuthInfo2(<any>response_);
                } catch (e) {
                    return <Observable<AuthInfoRes>><any>_observableThrow(e);
                }
            } else
                return <Observable<AuthInfoRes>><any>_observableThrow(response_);
        }));
    }

    protected processAuthInfo2(response: HttpResponseBase): Observable<AuthInfoRes> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AuthInfoRes.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<AuthInfoRes>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    changePassword(body: ChangePasswordReq | undefined): Observable<ChangePasswordRes> {
        let url_ = this.baseUrl + "/v1/Auth/ChangePassword";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processChangePassword(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processChangePassword(<any>response_);
                } catch (e) {
                    return <Observable<ChangePasswordRes>><any>_observableThrow(e);
                }
            } else
                return <Observable<ChangePasswordRes>><any>_observableThrow(response_);
        }));
    }

    protected processChangePassword(response: HttpResponseBase): Observable<ChangePasswordRes> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ChangePasswordRes.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ChangePasswordRes.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ChangePasswordRes>(<any>null);
    }

    /**
     * @param api_version (optional) The requested API version
     * @param body (optional) 
     * @return Success
     */
    changePassword2(api_version: string | undefined, body: ChangePasswordReq | undefined): Observable<ChangePasswordRes> {
        let url_ = this.baseUrl + "/Auth/ChangePassword?";
        if (api_version === null)
            throw new Error("The parameter 'api_version' cannot be null.");
        else if (api_version !== undefined)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processChangePassword2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processChangePassword2(<any>response_);
                } catch (e) {
                    return <Observable<ChangePasswordRes>><any>_observableThrow(e);
                }
            } else
                return <Observable<ChangePasswordRes>><any>_observableThrow(response_);
        }));
    }

    protected processChangePassword2(response: HttpResponseBase): Observable<ChangePasswordRes> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ChangePasswordRes.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ChangePasswordRes.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ChangePasswordRes>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    sendPasswordResetEMail(body: SendPasswordResetEMailReq | undefined): Observable<SendPasswordResetEMailRes> {
        let url_ = this.baseUrl + "/v1/Auth/SendPasswordResetEMail";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSendPasswordResetEMail(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendPasswordResetEMail(<any>response_);
                } catch (e) {
                    return <Observable<SendPasswordResetEMailRes>><any>_observableThrow(e);
                }
            } else
                return <Observable<SendPasswordResetEMailRes>><any>_observableThrow(response_);
        }));
    }

    protected processSendPasswordResetEMail(response: HttpResponseBase): Observable<SendPasswordResetEMailRes> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SendPasswordResetEMailRes.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SendPasswordResetEMailRes>(<any>null);
    }

    /**
     * @param api_version (optional) The requested API version
     * @param body (optional) 
     * @return Success
     */
    sendPasswordResetEMail2(api_version: string | undefined, body: SendPasswordResetEMailReq | undefined): Observable<SendPasswordResetEMailRes> {
        let url_ = this.baseUrl + "/Auth/SendPasswordResetEMail?";
        if (api_version === null)
            throw new Error("The parameter 'api_version' cannot be null.");
        else if (api_version !== undefined)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSendPasswordResetEMail2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendPasswordResetEMail2(<any>response_);
                } catch (e) {
                    return <Observable<SendPasswordResetEMailRes>><any>_observableThrow(e);
                }
            } else
                return <Observable<SendPasswordResetEMailRes>><any>_observableThrow(response_);
        }));
    }

    protected processSendPasswordResetEMail2(response: HttpResponseBase): Observable<SendPasswordResetEMailRes> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SendPasswordResetEMailRes.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SendPasswordResetEMailRes>(<any>null);
    }

    /**
     * @return Success
     */
    captchaSiteKey(): Observable<string> {
        let url_ = this.baseUrl + "/v1/Auth/CaptchaSiteKey";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCaptchaSiteKey(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCaptchaSiteKey(<any>response_);
                } catch (e) {
                    return <Observable<string>><any>_observableThrow(e);
                }
            } else
                return <Observable<string>><any>_observableThrow(response_);
        }));
    }

    protected processCaptchaSiteKey(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(<any>null);
    }

    /**
     * @param api_version (optional) The requested API version
     * @return Success
     */
    captchaSiteKey2(api_version: string | undefined): Observable<string> {
        let url_ = this.baseUrl + "/Auth/CaptchaSiteKey?";
        if (api_version === null)
            throw new Error("The parameter 'api_version' cannot be null.");
        else if (api_version !== undefined)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCaptchaSiteKey2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCaptchaSiteKey2(<any>response_);
                } catch (e) {
                    return <Observable<string>><any>_observableThrow(e);
                }
            } else
                return <Observable<string>><any>_observableThrow(response_);
        }));
    }

    protected processCaptchaSiteKey2(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(<any>null);
    }
}

export enum AuthClientType {
    WebService = "WebService",
    CustomerPortal = "CustomerPortal",
    AdminPortal = "AdminPortal",
}

export class AccessTokenReq implements IAccessTokenReq {
    clientType?: AuthClientType;
    eMail!: string;
    password!: string;
    myProperty?: number;
    captchaCode?: string | undefined;
    twoFactorCode?: string | undefined;
    customerIdentity?: string | undefined;

    constructor(data?: IAccessTokenReq) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.clientType = _data["clientType"];
            this.eMail = _data["eMail"];
            this.password = _data["password"];
            this.myProperty = _data["myProperty"];
            this.captchaCode = _data["captchaCode"];
            this.twoFactorCode = _data["twoFactorCode"];
            this.customerIdentity = _data["customerIdentity"];
        }
    }

    static fromJS(data: any): AccessTokenReq {
        data = typeof data === 'object' ? data : {};
        let result = new AccessTokenReq();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["clientType"] = this.clientType;
        data["eMail"] = this.eMail;
        data["password"] = this.password;
        data["myProperty"] = this.myProperty;
        data["captchaCode"] = this.captchaCode;
        data["twoFactorCode"] = this.twoFactorCode;
        data["customerIdentity"] = this.customerIdentity;
        return data; 
    }
}

export interface IAccessTokenReq {
    clientType?: AuthClientType;
    eMail: string;
    password: string;
    myProperty?: number;
    captchaCode?: string | undefined;
    twoFactorCode?: string | undefined;
    customerIdentity?: string | undefined;
}

export class AccessTokenResCustomerInfo implements IAccessTokenResCustomerInfo {
    identity?: string | undefined;
    title?: string | undefined;

    constructor(data?: IAccessTokenResCustomerInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.identity = _data["identity"];
            this.title = _data["title"];
        }
    }

    static fromJS(data: any): AccessTokenResCustomerInfo {
        data = typeof data === 'object' ? data : {};
        let result = new AccessTokenResCustomerInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["identity"] = this.identity;
        data["title"] = this.title;
        return data; 
    }
}

export interface IAccessTokenResCustomerInfo {
    identity?: string | undefined;
    title?: string | undefined;
}

export class AccessTokenResUserInfo implements IAccessTokenResUserInfo {
    name?: string | undefined;
    surname?: string | undefined;
    loggedCustomerIdentity?: string | undefined;
    loggedCustomerTitle?: string | undefined;

    constructor(data?: IAccessTokenResUserInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.surname = _data["surname"];
            this.loggedCustomerIdentity = _data["loggedCustomerIdentity"];
            this.loggedCustomerTitle = _data["loggedCustomerTitle"];
        }
    }

    static fromJS(data: any): AccessTokenResUserInfo {
        data = typeof data === 'object' ? data : {};
        let result = new AccessTokenResUserInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["surname"] = this.surname;
        data["loggedCustomerIdentity"] = this.loggedCustomerIdentity;
        data["loggedCustomerTitle"] = this.loggedCustomerTitle;
        return data; 
    }
}

export interface IAccessTokenResUserInfo {
    name?: string | undefined;
    surname?: string | undefined;
    loggedCustomerIdentity?: string | undefined;
    loggedCustomerTitle?: string | undefined;
}

export class AccessTokenRes implements IAccessTokenRes {
    isSuccessed?: boolean;
    accessToken?: string | undefined;
    refreshToken?: string | undefined;
    resultMessageCode?: string | undefined;
    traceId?: string | undefined;
    captchaCodeRequired?: boolean | undefined;
    captchaSiteKey?: string | undefined;
    twoFactorCodeRequired?: boolean | undefined;
    twoFactorCodeExpiredTime?: Date | undefined;
    customers?: AccessTokenResCustomerInfo[] | undefined;
    userInfo?: AccessTokenResUserInfo;

    constructor(data?: IAccessTokenRes) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isSuccessed = _data["isSuccessed"];
            this.accessToken = _data["accessToken"];
            this.refreshToken = _data["refreshToken"];
            this.resultMessageCode = _data["resultMessageCode"];
            this.traceId = _data["traceId"];
            this.captchaCodeRequired = _data["captchaCodeRequired"];
            this.captchaSiteKey = _data["captchaSiteKey"];
            this.twoFactorCodeRequired = _data["twoFactorCodeRequired"];
            this.twoFactorCodeExpiredTime = _data["twoFactorCodeExpiredTime"] ? new Date(_data["twoFactorCodeExpiredTime"].toString()) : <any>undefined;
            if (Array.isArray(_data["customers"])) {
                this.customers = [] as any;
                for (let item of _data["customers"])
                    this.customers!.push(AccessTokenResCustomerInfo.fromJS(item));
            }
            this.userInfo = _data["userInfo"] ? AccessTokenResUserInfo.fromJS(_data["userInfo"]) : <any>undefined;
        }
    }

    static fromJS(data: any): AccessTokenRes {
        data = typeof data === 'object' ? data : {};
        let result = new AccessTokenRes();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isSuccessed"] = this.isSuccessed;
        data["accessToken"] = this.accessToken;
        data["refreshToken"] = this.refreshToken;
        data["resultMessageCode"] = this.resultMessageCode;
        data["traceId"] = this.traceId;
        data["captchaCodeRequired"] = this.captchaCodeRequired;
        data["captchaSiteKey"] = this.captchaSiteKey;
        data["twoFactorCodeRequired"] = this.twoFactorCodeRequired;
        data["twoFactorCodeExpiredTime"] = this.twoFactorCodeExpiredTime ? this.twoFactorCodeExpiredTime.toISOString() : <any>undefined;
        if (Array.isArray(this.customers)) {
            data["customers"] = [];
            for (let item of this.customers)
                data["customers"].push(item.toJSON());
        }
        data["userInfo"] = this.userInfo ? this.userInfo.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IAccessTokenRes {
    isSuccessed?: boolean;
    accessToken?: string | undefined;
    refreshToken?: string | undefined;
    resultMessageCode?: string | undefined;
    traceId?: string | undefined;
    captchaCodeRequired?: boolean | undefined;
    captchaSiteKey?: string | undefined;
    twoFactorCodeRequired?: boolean | undefined;
    twoFactorCodeExpiredTime?: Date | undefined;
    customers?: AccessTokenResCustomerInfo[] | undefined;
    userInfo?: AccessTokenResUserInfo;
}

export class RefreshTokenReq implements IRefreshTokenReq {
    accessToken!: string;
    refreshToken!: string;
    captchaCode?: string | undefined;

    constructor(data?: IRefreshTokenReq) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.accessToken = _data["accessToken"];
            this.refreshToken = _data["refreshToken"];
            this.captchaCode = _data["captchaCode"];
        }
    }

    static fromJS(data: any): RefreshTokenReq {
        data = typeof data === 'object' ? data : {};
        let result = new RefreshTokenReq();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accessToken"] = this.accessToken;
        data["refreshToken"] = this.refreshToken;
        data["captchaCode"] = this.captchaCode;
        return data; 
    }
}

export interface IRefreshTokenReq {
    accessToken: string;
    refreshToken: string;
    captchaCode?: string | undefined;
}

export class RefreshTokenRes implements IRefreshTokenRes {
    isSuccessed?: boolean;
    accessToken?: string | undefined;
    refreshToken?: string | undefined;
    resultMessageCode?: string | undefined;
    traceId?: string | undefined;
    captchaCodeRequired?: boolean | undefined;
    captchaSiteKey?: string | undefined;

    constructor(data?: IRefreshTokenRes) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isSuccessed = _data["isSuccessed"];
            this.accessToken = _data["accessToken"];
            this.refreshToken = _data["refreshToken"];
            this.resultMessageCode = _data["resultMessageCode"];
            this.traceId = _data["traceId"];
            this.captchaCodeRequired = _data["captchaCodeRequired"];
            this.captchaSiteKey = _data["captchaSiteKey"];
        }
    }

    static fromJS(data: any): RefreshTokenRes {
        data = typeof data === 'object' ? data : {};
        let result = new RefreshTokenRes();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isSuccessed"] = this.isSuccessed;
        data["accessToken"] = this.accessToken;
        data["refreshToken"] = this.refreshToken;
        data["resultMessageCode"] = this.resultMessageCode;
        data["traceId"] = this.traceId;
        data["captchaCodeRequired"] = this.captchaCodeRequired;
        data["captchaSiteKey"] = this.captchaSiteKey;
        return data; 
    }
}

export interface IRefreshTokenRes {
    isSuccessed?: boolean;
    accessToken?: string | undefined;
    refreshToken?: string | undefined;
    resultMessageCode?: string | undefined;
    traceId?: string | undefined;
    captchaCodeRequired?: boolean | undefined;
    captchaSiteKey?: string | undefined;
}

export class ChangeCustomerReq implements IChangeCustomerReq {
    accessToken!: string;
    customerIdentity!: string;

    constructor(data?: IChangeCustomerReq) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.accessToken = _data["accessToken"];
            this.customerIdentity = _data["customerIdentity"];
        }
    }

    static fromJS(data: any): ChangeCustomerReq {
        data = typeof data === 'object' ? data : {};
        let result = new ChangeCustomerReq();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accessToken"] = this.accessToken;
        data["customerIdentity"] = this.customerIdentity;
        return data; 
    }
}

export interface IChangeCustomerReq {
    accessToken: string;
    customerIdentity: string;
}

export class ChangeCustomerRes implements IChangeCustomerRes {
    isSuccessed?: boolean;
    accessToken?: string | undefined;
    refreshToken?: string | undefined;
    resultMessageCode?: string | undefined;
    traceId?: string | undefined;
    customers?: AccessTokenResCustomerInfo[] | undefined;
    userInfo?: AccessTokenResUserInfo;

    constructor(data?: IChangeCustomerRes) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isSuccessed = _data["isSuccessed"];
            this.accessToken = _data["accessToken"];
            this.refreshToken = _data["refreshToken"];
            this.resultMessageCode = _data["resultMessageCode"];
            this.traceId = _data["traceId"];
            if (Array.isArray(_data["customers"])) {
                this.customers = [] as any;
                for (let item of _data["customers"])
                    this.customers!.push(AccessTokenResCustomerInfo.fromJS(item));
            }
            this.userInfo = _data["userInfo"] ? AccessTokenResUserInfo.fromJS(_data["userInfo"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ChangeCustomerRes {
        data = typeof data === 'object' ? data : {};
        let result = new ChangeCustomerRes();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isSuccessed"] = this.isSuccessed;
        data["accessToken"] = this.accessToken;
        data["refreshToken"] = this.refreshToken;
        data["resultMessageCode"] = this.resultMessageCode;
        data["traceId"] = this.traceId;
        if (Array.isArray(this.customers)) {
            data["customers"] = [];
            for (let item of this.customers)
                data["customers"].push(item.toJSON());
        }
        data["userInfo"] = this.userInfo ? this.userInfo.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IChangeCustomerRes {
    isSuccessed?: boolean;
    accessToken?: string | undefined;
    refreshToken?: string | undefined;
    resultMessageCode?: string | undefined;
    traceId?: string | undefined;
    customers?: AccessTokenResCustomerInfo[] | undefined;
    userInfo?: AccessTokenResUserInfo;
}

export class AuthInfoServiceInfo implements IAuthInfoServiceInfo {
    code?: string | undefined;
    description?: string | undefined;

    constructor(data?: IAuthInfoServiceInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.code = _data["code"];
            this.description = _data["description"];
        }
    }

    static fromJS(data: any): AuthInfoServiceInfo {
        data = typeof data === 'object' ? data : {};
        let result = new AuthInfoServiceInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["description"] = this.description;
        return data; 
    }
}

export interface IAuthInfoServiceInfo {
    code?: string | undefined;
    description?: string | undefined;
}

export class AuthInfoRightInfo implements IAuthInfoRightInfo {
    code?: string | undefined;
    isVisible?: boolean;
    isEnabled?: boolean;
    hasLicense?: boolean;

    constructor(data?: IAuthInfoRightInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.code = _data["code"];
            this.isVisible = _data["isVisible"];
            this.isEnabled = _data["isEnabled"];
            this.hasLicense = _data["hasLicense"];
        }
    }

    static fromJS(data: any): AuthInfoRightInfo {
        data = typeof data === 'object' ? data : {};
        let result = new AuthInfoRightInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["isVisible"] = this.isVisible;
        data["isEnabled"] = this.isEnabled;
        data["hasLicense"] = this.hasLicense;
        return data; 
    }
}

export interface IAuthInfoRightInfo {
    code?: string | undefined;
    isVisible?: boolean;
    isEnabled?: boolean;
    hasLicense?: boolean;
}

export class AuthInfoRes implements IAuthInfoRes {
    avaiableServices?: AuthInfoServiceInfo[] | undefined;
    rightInfos?: AuthInfoRightInfo[] | undefined;

    constructor(data?: IAuthInfoRes) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["avaiableServices"])) {
                this.avaiableServices = [] as any;
                for (let item of _data["avaiableServices"])
                    this.avaiableServices!.push(AuthInfoServiceInfo.fromJS(item));
            }
            if (Array.isArray(_data["rightInfos"])) {
                this.rightInfos = [] as any;
                for (let item of _data["rightInfos"])
                    this.rightInfos!.push(AuthInfoRightInfo.fromJS(item));
            }
        }
    }

    static fromJS(data: any): AuthInfoRes {
        data = typeof data === 'object' ? data : {};
        let result = new AuthInfoRes();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.avaiableServices)) {
            data["avaiableServices"] = [];
            for (let item of this.avaiableServices)
                data["avaiableServices"].push(item.toJSON());
        }
        if (Array.isArray(this.rightInfos)) {
            data["rightInfos"] = [];
            for (let item of this.rightInfos)
                data["rightInfos"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IAuthInfoRes {
    avaiableServices?: AuthInfoServiceInfo[] | undefined;
    rightInfos?: AuthInfoRightInfo[] | undefined;
}

export class ChangePasswordReq implements IChangePasswordReq {
    clientType?: AuthClientType;
    eMail?: string | undefined;
    oldPassword?: string | undefined;
    resetPasswordKey?: string | undefined;
    newPassword!: string;
    captchaCode!: string;

    constructor(data?: IChangePasswordReq) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.clientType = _data["clientType"];
            this.eMail = _data["eMail"];
            this.oldPassword = _data["oldPassword"];
            this.resetPasswordKey = _data["resetPasswordKey"];
            this.newPassword = _data["newPassword"];
            this.captchaCode = _data["captchaCode"];
        }
    }

    static fromJS(data: any): ChangePasswordReq {
        data = typeof data === 'object' ? data : {};
        let result = new ChangePasswordReq();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["clientType"] = this.clientType;
        data["eMail"] = this.eMail;
        data["oldPassword"] = this.oldPassword;
        data["resetPasswordKey"] = this.resetPasswordKey;
        data["newPassword"] = this.newPassword;
        data["captchaCode"] = this.captchaCode;
        return data; 
    }
}

export interface IChangePasswordReq {
    clientType?: AuthClientType;
    eMail?: string | undefined;
    oldPassword?: string | undefined;
    resetPasswordKey?: string | undefined;
    newPassword: string;
    captchaCode: string;
}

export class ChangePasswordRes implements IChangePasswordRes {
    isSuccessed?: boolean;
    resultMessageCode?: string | undefined;
    captchaCodeRequired?: boolean | undefined;
    captchaSiteKey?: string | undefined;
    traceId?: string | undefined;

    constructor(data?: IChangePasswordRes) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isSuccessed = _data["isSuccessed"];
            this.resultMessageCode = _data["resultMessageCode"];
            this.captchaCodeRequired = _data["captchaCodeRequired"];
            this.captchaSiteKey = _data["captchaSiteKey"];
            this.traceId = _data["traceId"];
        }
    }

    static fromJS(data: any): ChangePasswordRes {
        data = typeof data === 'object' ? data : {};
        let result = new ChangePasswordRes();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isSuccessed"] = this.isSuccessed;
        data["resultMessageCode"] = this.resultMessageCode;
        data["captchaCodeRequired"] = this.captchaCodeRequired;
        data["captchaSiteKey"] = this.captchaSiteKey;
        data["traceId"] = this.traceId;
        return data; 
    }
}

export interface IChangePasswordRes {
    isSuccessed?: boolean;
    resultMessageCode?: string | undefined;
    captchaCodeRequired?: boolean | undefined;
    captchaSiteKey?: string | undefined;
    traceId?: string | undefined;
}

export class SendPasswordResetEMailReq implements ISendPasswordResetEMailReq {
    eMail!: string;
    captchaCode!: string;

    constructor(data?: ISendPasswordResetEMailReq) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.eMail = _data["eMail"];
            this.captchaCode = _data["captchaCode"];
        }
    }

    static fromJS(data: any): SendPasswordResetEMailReq {
        data = typeof data === 'object' ? data : {};
        let result = new SendPasswordResetEMailReq();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["eMail"] = this.eMail;
        data["captchaCode"] = this.captchaCode;
        return data; 
    }
}

export interface ISendPasswordResetEMailReq {
    eMail: string;
    captchaCode: string;
}

export class SendPasswordResetEMailRes implements ISendPasswordResetEMailRes {
    captchaCodeRequired?: boolean | undefined;
    captchaSiteKey?: string | undefined;
    resultMessageCode?: string | undefined;
    traceId?: string | undefined;

    constructor(data?: ISendPasswordResetEMailRes) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.captchaCodeRequired = _data["captchaCodeRequired"];
            this.captchaSiteKey = _data["captchaSiteKey"];
            this.resultMessageCode = _data["resultMessageCode"];
            this.traceId = _data["traceId"];
        }
    }

    static fromJS(data: any): SendPasswordResetEMailRes {
        data = typeof data === 'object' ? data : {};
        let result = new SendPasswordResetEMailRes();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["captchaCodeRequired"] = this.captchaCodeRequired;
        data["captchaSiteKey"] = this.captchaSiteKey;
        data["resultMessageCode"] = this.resultMessageCode;
        data["traceId"] = this.traceId;
        return data; 
    }
}

export interface ISendPasswordResetEMailRes {
    captchaCodeRequired?: boolean | undefined;
    captchaSiteKey?: string | undefined;
    resultMessageCode?: string | undefined;
    traceId?: string | undefined;
}

export class ApiException extends Error {
    message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): Observable<any> {
    if (result !== null && result !== undefined)
        return _observableThrow(result);
    else
        return _observableThrow(new ApiException(message, status, response, headers, null));
}

function blobToText(blob: any): Observable<string> {
    return new Observable<string>((observer: any) => {
        if (!blob) {
            observer.next("");
            observer.complete();
        } else {
            let reader = new FileReader();
            reader.onload = event => {
                observer.next((<any>event.target).result);
                observer.complete();
            };
            reader.readAsText(blob);
        }
    });
}